var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownDoubleTreeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4629 13.0375L14.4024 11.977L12.5004 13.879V4H11.0004V13.879L9.09839 11.977L8.03789 13.0375L11.7504 16.75L15.4629 13.0375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46289 13.0375L6.40239 11.977L4.50039 13.879L4.50039 4H3.00039L3.00039 13.879L1.09839 11.977L0.0378909 13.0375L3.75039 16.75L7.46289 13.0375Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5H12.5",
    stroke: "black",
    strokeWidth: 1.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5L8 -1.78814e-07",
    stroke: "black",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownDoubleTreeIcon);
export default __webpack_public_path__ + "static/media/arrow-down-double-tree-icon.f49e07a83e600438e8c35a0f9b11442c.svg";
export { ForwardRef as ReactComponent };